module.exports = __webpack_public_path__ + "static/img/case_detail_08_2.4a74747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_08_2.png
// module id = KRZb
// module chunks = 34